import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildSalesforceParamsQuery } from '../../utils/methods';
import request from '../../modules/Request/request';

export const getAccountLicenses = createAsyncThunk(
  'getAccountLicenses',
  async (object, { rejectWithValue }) => {
    const { accountId } = object;

    const query = { accountId };
    const finalQuery = buildSalesforceParamsQuery(query, object);

    const response = await request('/account-licenses', { method: 'GET', query: finalQuery });
    if (response.success) {
      return response.data;
    }
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
